import { Controller } from "@hotwired/stimulus"
import { get } from "@rails/request.js"

export default class extends Controller {
  static values = { period: Number, url: String }

  connect() {
    setTimeout(() => get(this.urlValue), this.periodValue * 1000)
  }
}
